import { styled } from 'styled-components';
import { IGlobaVariables } from './../../../components/Layout/styles';
import { IFooter3, defaultParams } from './params';

const Styles = styled.footer<{
  theme?: IGlobaVariables;
  $config: IFooter3;
}>`
  .footer {
    margin-bottom: 30px;
    &-wrapper {
      display: grid;
      grid-template-columns: 1fr;
    }

    &-siteName {
      margin: 25px 0 35px;
      padding-bottom: 30px;
      width: 100%;
      text-align: center;
      color: ${({ $config: styles }) => styles.group_siteNameLogo.color};
      font-family: ${({ $config: styles }) => styles.group_siteNameLogo.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_siteNameLogo.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_siteNameLogo.fontSize};
      border-bottom: 1px solid ${({ $config: styles }) => styles.borderColor};
      font-style: ${({ $config: styles }) => styles.group_navlinks.fontStyle};
    }

    &-navlinks {
      width: 100%;
      padding: 25px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      border-top: 1px solid ${({ $config: styles }) => styles.borderColor};
      border-bottom: 1px solid ${({ $config: styles }) => styles.borderColor};
      justify-content: ${({ $config: styles }) => {
        if (styles.group_navlinks.textAlign == 'right') return 'end';
        if (styles.group_navlinks.textAlign == 'center') return 'center';
        return 'start';
      }};
      a {
        flex-shrink: 0;
        color: ${({ $config: styles }) => styles.group_navlinks.color};
        font-family: ${({ $config: styles }) => styles.group_navlinks.fontFamily};
        font-weight: ${({ $config: styles }) => styles.group_navlinks.fontWeight};
        font-size: ${({ $config: styles }) => styles.group_navlinks.fontSize};
        line-height: ${({ $config: styles }) => styles.group_navlinks.lineHeight};
        font-style: ${({ $config: styles }) => styles.group_navlinks.fontStyle};
        text-decoration: ${({ $config: styles }) => styles.group_navlinks.textDecoration};

        &:hover {
          color: ${({ $config: styles }) => styles.group_navlinks.hover_color};
          text-decoration: ${({ $config: styles }) => styles.group_navlinks.hover_textDecoration};
        }
      }
    }

    &-categories {
      list-style-type: none;
      margin: 0 0 35px 0;
      padding: 0 0 0 20px;
      border-left: 1px solid ${({ $config: styles }) => styles.borderColor};
      &-category {
        a {
          display: block;
          color: ${({ $config: styles }) => styles.group_categories.color};
          font-family: ${({ $config: styles }) => styles.group_categories.fontFamily};
          font-weight: ${({ $config: styles }) => styles.group_categories.fontWeight};
          font-size: ${({ $config: styles }) => styles.group_categories.fontSize};
          line-height: ${({ $config: styles }) => styles.group_categories.lineHeight};
          font-style: ${({ $config: styles }) => styles.group_categories.fontStyle};
          text-decoration: ${({ $config: styles }) => styles.group_categories.textDecoration};

          &:hover {
            color: ${({ $config: styles }) => styles.group_categories.hover_color};
            text-decoration: ${({ $config: styles }) => styles.group_categories.hover_textDecoration};
          }
        }
      }
    }

    &-copyright {
      min-height: 55px;
      padding: 17px 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: ${({ $config: styles }) => styles.group_copyright.borderRadius};
      background: ${({ $config: styles }) => styles.group_copyright.backgroundColor};
      p {
        margin: 0;
        padding: 0;
        color: ${({ $config: styles }) => styles.group_copyright.color};
        font-family: ${({ $config: styles }) => styles.group_copyright.fontFamily};
        font-weight: ${({ $config: styles }) => styles.group_copyright.fontWeight};
        font-size: ${({ $config: styles }) => styles.group_copyright.fontSize};
        line-height: ${({ $config: styles }) => styles.group_copyright.lineHeight};
        font-style: ${({ $config: styles }) => styles.group_copyright.fontStyle};
        span {
          color: ${({ $config: styles }) => styles.group_copyright.group_sitename.color};
          font-weight: ${({ $config: styles }) => styles.group_copyright.group_sitename.fontWeight};
        }
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.md}) {
    .footer {
      &-categories {
        -moz-column-count: 3;
        -webkit-column-count: 3;
        column-count: 3;
        -moz-column-rule: 1px solid ${({ $config: styles }) => styles.borderColor};
        -webkit-column-rule: 1px solid ${({ $config: styles }) => styles.borderColor};
        column-rule: 1px solid ${({ $config: styles }) => styles.borderColor};
        gap: 30px;
        padding: 0 0 0 20px;
        margin-bottom: 50px;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}) {
    .footer {
      &-navlinks {
        flex-direction: row;
        margin-bottom: 20px;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.xl}) {
    .footer {
      &-wrapper {
        grid-template-columns: 1fr 1fr 1fr 1fr;
      }

      &-siteName {
        margin: 0;
        padding: 0;
        border-bottom: none;
        grid-column: 1/2;
      }

      &-navlinks {
        grid-column: 1/5;
      }

      &-categories {
        grid-column: 2/5;
      }
    }
  }
`;

export default Styles;
